import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../components/UI/Button';
import Card from '../components/UI/Card';
import { tools } from '../data/tools';
import './Home.css';

const Home = () => {
    return (
        <div className="home-page">
            <Helmet>
                <title>OnlineToolSphere - Premium Developer Tools</title>
                <meta name="description" content="A collection of premium, client-side developer tools including Prompt Builder, JSON Beautifier, JSON Compare, Text Compare, Image Compressor, Unit Converter, and more. Secure, fast, and free." />
                <meta property="og:title" content="OnlineToolSphere - Premium Developer Tools" />
                <meta property="og:description" content="A collection of premium, client-side developer tools including Prompt Builder, JSON Beautifier, JSON Compare, Text Compare, Image Compressor, Unit Converter, and more." />
                <meta property="og:url" content="https://onlinetoolsphere.com/" />
                <meta name="twitter:title" content="OnlineToolSphere - Premium Developer Tools" />
                <meta name="twitter:description" content="A collection of premium, client-side developer tools including Prompt Builder, JSON Beautifier, JSON Compare, Text Compare, Image Compressor, Unit Converter, and more." />
            </Helmet>
            <section className="hero">
                <div className="container hero-content">
                    <h1 className="hero-title">
                        Developer Tools for the <span className="text-gradient">Modern Web</span>
                    </h1>
                    <p className="hero-subtitle">
                        A collection of premium, client-side utilities to streamline your workflow.
                        Secure, fast, and beautiful.
                    </p>
                    <div className="hero-actions">
                        <a href="#tools-section" className="btn btn-primary">
                            Explore Tools <ArrowRight size={18} style={{ marginLeft: '0.5rem' }} />
                        </a>
                    </div>
                </div>
            </section>

            <section id="tools-section" className="tools-grid container">
                {tools.map((tool) => (
                    <Link key={tool.id} to={`${tool.path}/`}>
                        <Card className="tool-card">
                            <div className="tool-icon-wrapper" style={{ backgroundColor: tool.color }}>
                                <tool.icon size={24} color="white" />
                            </div>
                            <h3 className="tool-title">{tool.title}</h3>
                            <p className="tool-description">{tool.description}</p>
                        </Card>
                    </Link>
                ))}
            </section>
        </div>
    );
};

export default Home;
